import React, { Component } from 'react';
import axios from "axios";
import PropTypes from 'prop-types';
import { connect, ReactReduxContext } from 'react-redux';
import { withCookies, Cookies } from 'react-cookie';

import { HeaderNav } from 'cb-design-system';
import { ducks } from '../../ducks';

import { AzureADClient, authProviderClient, AuthenticationState } from '../../AuthComponent';
import { authConfig } from '../../AuthProvider';

const accountOperations = ducks.account.operations
const headerOperations = ducks.header.operations
const searchOperations = ducks.search.operations
const retailOperations = ducks.retail.operations
const loyaltyOperations = ducks.loyalty.operations
const { cart: cartDuck } = ducks;
const { operations } = cartDuck
const { closeAddTo, getCart: duckGetCart } = operations


export const HeaderNavComponent = (props) => {
  const {context, store, authenticationState, accountInfo, handleLogout} = props


  return (
  <HeaderNav
    {...props}
    store={store}
    handleLogout={handleLogout}
    navigation={context.navigationItems}
    model={context.model}
    hamburgerMenuLinks={context.hamburgerMenuLinks}
    hamburgerMenuButtons={context.hamburgerMenuButtons}
    searchResults={context.props.results}
    toggleWaitlist={context.props.toggleWaitlist}
    accountNavVisible={context.props.accountNavVisible}
    secondaryNavVisible={context.props.secondaryNavVisible}
    toggleSidenav={context.props.toggleSidenav}
    searchChangeHandler={context.handleInputChange}
    searchSubmitHandler={context.handleSearch}
    authenticationState={authenticationState}
    accountInfo={accountInfo}
    handleLogin={context.handleLogin}
  />
)}

class Header extends Component {

  constructor(props) {
    super(props);

    this.fields = props.fields?.data?.fields  || {} ;
    this.navigationItems = props.fields?.data?.navigationItems || {children: []};
    this.hamburgerMenuLinks  = props.fields?.data?.hamburgerMenuLinks || {children: []};
    this.hamburgerMenuButtons = props.fields?.data?.hamburgerMenuButtons || {children: []};
    this.handleInputChange = this.handleInputChange.bind(this);

    const { cookies } = props;

    this.state = {
      loggedin: cookies.get('scLoggedin') || false,
      getAccountInfoState: false
    };

    this.model = {
      logo: {
        image: this.fields.logo?.jss || {},
        url: this.fields.logoUrl?.jss || {}
      },
      pegPointLinkNotLoggedIn: this.fields.pegPointLinkNotLoggedIn?.jss,
      pegPointLinkLoggedIn: this.fields.pegPointLinkLoggedIn?.jss,
      pegPointAlt: this.fields.pegPointAlt?.jss,
      pegIconAlt: this.fields.pegIconAlt?.jss,
      search: {
        searchPlaceholder: this.fields.searchPlaceholder?.jss || {},
        searchResultPageUrl: this.fields.searchResultPageUrl?.jss || {}
      },
      account: {
        signInButtonText: this.fields.signInButtonText?.jss || {},
        registerButtonText: this.fields.registerButtonText?.jss || {},
        createAccountModelTitle: this.fields.createAccountModelTitle?.jss || {},
        dontHaveAnAccountText: this.fields.dontHaveAnAccountText?.jss || {},
        signInLink: this.fields.signInLink?.jss || {}
      },
      searchChangeHandler: this.handleInputChange,
    }
  }

  componentDidMount() {

    const queryRedirect = window.localStorage.getItem("LogoutRedirectUrl") || null;
    window.localStorage.removeItem("LogoutRedirectUrl");
    // Get the current URL
    const redirectURL = window.location.pathname
    // Get the query string part of the URL
    const queryParams = window.location.search;

    if (queryRedirect && queryRedirect !== redirectURL + queryParams) {
      window.history.pushState({}, '', window.location.origin + queryRedirect);
      window.location = window.location.origin + queryRedirect
    }

    const {enteredSearchText, changeEnteredSearchText, setPageSize, query } = this.props;

    if (!enteredSearchText && query) {
      changeEnteredSearchText(query, 7);
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.state.loggedin === 'true' && this.props.loggedin && this.props.account?.aadResponse?.jwtIdToken) {
      if (!this.props.loyalty?.account?.FirstName && this.props.account?.aadResponse?.account?.idToken?.signInName && !this.state.getAccountInfoState) {
        this.setState({ getAccountInfoState: true })
        this.props.getAccountInformation()
      }
    }
  }

  componentWillReceiveProps(newProps) {
     if(newProps.loggedin !== this.props.loggedin){
      if(!this.state.loggedin) {
        if(newProps.account?.aadResponse?.jwtIdToken) {
          this.props.postAccount(newProps.account.aadResponse.jwtIdToken);
          const { cookies } = this.props;
          cookies.set('scLoggedin', true, { path: '/' });
          this.state = {
            loggedin: true
          };
        }
      }
    }
  }

  handleLogin() {
    if (this.model.account.signInLink?.value?.href) {
      // Get the current URL
      const redirectURL = window.location.pathname
      // Get the query string part of the URL
      const queryParams = window.location.search;

      window.localStorage.setItem("LoyaltyLogInRedirectUrl", redirectURL + queryParams)
      
      window.location.href = this.model.account.signInLink.value.href
    }
  }

  handleInputChange(value) {
    if (this.props.enteredSearchText !== value) {
      this.props.query = value;
      this.props.changeEnteredSearchText(this.props.query, 7);
    }
  }

  handlePasswordReset = (error) => {
    authProviderClient.setAuthenticationParameters ({
      authority: `${authConfig.domain}/${authConfig.mfaPasswordPolicy}`,
    })

    authProviderClient.login()
  }

  render() {
    return(
      <ReactReduxContext.Consumer>
        {((context) => {
          return (
            <AzureADClient forceLogin={false} provider={authProviderClient} reduxStore={context.store}>
            {
              ({login, logout, authenticationState, error, accountInfo}) => {

                if(error  && error?.errorMessage?.indexOf("AADB2C90118") >= 0) {
                  this.handlePasswordReset(error);
                }

                if(error  && error?.errorMessage?.indexOf("AADB2C90091") >= 0) {
                 // user cancelled
                }

                const token = this.props.account?.aadResponse?.jwtIdToken;
                if(token) {
                  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                } else {
                  delete axios.defaults.headers.common['Authorization'];
                }
                return (
                  <HeaderNavComponent
                    {...this.props}
                    store={context.store}
                    authenticationState={authenticationState}
                    accountInfo={accountInfo}
                    handleLogout={logout}
                    context={this}
                  />
                )
              }}
            </AzureADClient>
          )}
        ).bind(this)
      }
      </ReactReduxContext.Consumer>
    );
  }
};

Header.propTypes = {
  changeEnteredSearchText: PropTypes.func,
  enteredSearchText: PropTypes.string,
  changeQueryText: PropTypes.func
}

const mapStateToProps = (state) => {

  return {
    account: state.account,
    loggedin: state.account?.loggedin,
    waitlistActive: state.header.waitlistActive,
    waitlistAvailable: state.location.location?.waitlist_flag && (state.location.location.webaheadstatus === 'Available'),
    orderOnline: state.location.location?.OnlineOrdering,
    temporarilyClosed: state.location.location?.TemporarilyClosed,
    secondaryNavVisible: state.header.secondaryNavVisible,
    accountNavVisible: state.header.accountNavVisible,
    enteredSearchText: state.search.enteredSearchText,
    query: state.search.searchTerm,
    isFetching: state.search.isFetching,
    results: state.search.searchResults,
    addTo : state.cart.addedToCart,
    newItem: state.cart.newItem || {},
    shopNav: state.retail?.retailCategories || [],
    offlineCart: state.offline.cart,
    loyalty: state.loyalty,
  };
}

const mapDispatchToProps = (dispatch) => ({
  toggleWaitlist: () => dispatch(headerOperations.toggleWaitlist()),
  toggleSidenav: () => dispatch(headerOperations.toggleSidenav()),
  changeEnteredSearchText: (text, pageSize) => dispatch(searchOperations.termChange(text, pageSize)),
  performSearch: () => dispatch(searchOperations.termChange()),
  changeQueryText: (text, pageSize) => dispatch(searchOperations.termChange(text, pageSize)),
  setPageSize: pageSize => dispatch(searchOperations.setPageSize(pageSize)),
  close: () => dispatch(closeAddTo()),
  postAccount: token => dispatch(accountOperations.postAccount(token)),
  getShopCategories: () => dispatch(retailOperations.getCategories()),  
  getCart: (jwtIdToken) => dispatch(duckGetCart(jwtIdToken)),
  getAccountInformation: () => dispatch(loyaltyOperations.handleGetAccountInformation()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withCookies(Header));
